





























import Vue from 'vue'
import ClientArchive from '@/components/client-work/client-archive.vue'
import CategoryFilter, { Category } from '@/components/client-work/category-filter.vue'
import { WorksItem, formatWorksItem } from '@/types/works'

const WP_SITE_URL = process.env.NODE_ENV === 'development'
  ? process.env.VUE_APP_DEV_WP_SITE_URL
  : process.env.VUE_APP_PRO_WP_SITE_URL

export default Vue.extend({
  components: {
    ClientArchive,
    CategoryFilter
  },

  data() {
    return {
      works: [] as WorksItem[],
      categories: [] as Category[],
      selectedCategory: -1,
      page: 1,
      perPage: 12,
      hasMore: true,
      loading: false
    }
  },
  
  async created() {
    await this.fetchCategories()
    await this.fetchWorks()
    window.addEventListener('scroll', this.onScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    async fetchCategories() {
      const query = new URLSearchParams({
        per_page: '100'
      })
      const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/categories?${query}`)
      this.categories = await response.json() as Category[]
      this.categories = this.categories.filter(category => category.count > 0)
      this.categories = this.categories.filter(category => ['Webサイト', 'パッケージ', 'パンフレット', 'ロゴ', '冊子'].includes(category.name))
    },

    async fetchWorks(reset = false) {
      if (reset) {
        this.page = 1
        this.works = []
        this.hasMore = true
      }
      
      if (this.loading || !this.hasMore) return
      this.loading = true

      const query = new URLSearchParams({
        per_page: String(this.perPage),
        page: String(this.page),
        orderby: 'date',
        order: 'desc',
        _embed: '1',
        acf_format: 'standard'
      })

      if (this.selectedCategory > -1) {
        query.append('categories', String(this.selectedCategory))
      }

      try {
        const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/works?${query}`)
        if (!response.ok) throw new Error(response.statusText)

        const posts = await response.json()
        const items = posts.map((post: any) => formatWorksItem(post))

        if (items.length < this.perPage) {
          this.hasMore = false
        }

        if (reset) {
          this.works = items
        } else {
          this.works.push(...items)
        }

        this.page++
      } catch (error) {
        console.error(error)
        this.hasMore = false
      } finally {
        this.loading = false
      }
    },

    onCategoryChange(categoryId: number) {
      if (this.selectedCategory !== categoryId) {
        this.selectedCategory = categoryId
      } else {
        this.selectedCategory = -1
      }
      console.log(this.selectedCategory)
      this.fetchWorks(true)
    },

    onScroll() {
      if (this.loading || !this.hasMore) return

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      if (scrollTop + windowHeight >= documentHeight - 200) {
        this.fetchWorks()
      }
    }
  }
})
